// src/features/auth/authSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: sessionStorage.getItem("accessToken"),
  refreshToken: sessionStorage.getItem("refreshToken"),
  user: JSON.parse(sessionStorage.getItem("user")) || {},
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action) {
      const { token, refreshToken, user } = action.payload;

      // ✅ Save to sessionStorage
      sessionStorage.setItem("accessToken", token);
      sessionStorage.setItem("refreshToken", refreshToken);
      sessionStorage.setItem("user", JSON.stringify(user));

      state.token = token;
      state.refreshToken = refreshToken;
      state.user = user;
    },

    logout(state) {
      sessionStorage.removeItem("accessToken");
      sessionStorage.removeItem("refreshToken");
      sessionStorage.removeItem("user");

      state.token = "";
      state.refreshToken = "";
      state.user = {};
    },

    setToken(state, action) {
      state.token = action.payload;
      sessionStorage.setItem("accessToken", action.payload);
    },

    clearToken(state) {
      state.token = "";
      sessionStorage.removeItem("accessToken");
    },

    setRefreshToken(state, action) {
      state.refreshToken = action.payload;
      sessionStorage.setItem("refreshToken", action.payload);
    },

    clearRefreshToken(state) {
      state.refreshToken = "";
      sessionStorage.removeItem("refreshToken");
    },

    setUser(state, action) {
      state.user = action.payload;
      sessionStorage.setItem("user", JSON.stringify(action.payload));
    },

    clearUser(state) {
      state.user = {};
      sessionStorage.removeItem("user");
    },
  },
});

export const {
  login,
  logout,
  setToken,
  clearToken,
  setRefreshToken,
  clearRefreshToken,
  setUser,
  clearUser,
} = authSlice.actions;

export default authSlice.reducer;
